define('NetSuite.SuiteCommCPQ.Main.View.Sku', [
        'netsuite_suitecommcpq_main_sku.tpl',
        'Utils', 'Backbone', 'jQuery', 'underscore', 'NetSuite.SuiteCommCPQ.Main.Configuration',
        'NetSuite.SuiteCommCPQ.Main.Core', 'NetSuite.SuiteCommCPQ.Main.Debug'
    ],
    function(netsuite_suitecommcpq_main_sku_tpl, Utils, Backbone, jQuery, _, Configuration, Core, Debugger) {
        'use strict';
        // @class NetSuite.SuiteCommCPQ.Main.View.Sku @extends Backbone.View
        return Backbone.View.extend({
            template: netsuite_suitecommcpq_main_sku_tpl,
            initialize: function(options) {
                Debugger.log('VCPQ','ViewSku : init');
            },
            events: {},
            bindings: {},
            childViews: {
            },
            loaded: function loaded() {},
            //@method getContext @return NetSuite.SuiteCommCPQ.Main.View.Sku.Context
            getContext: function getContext() {
                //@class VT.VGen.VModule.View.Context
                return {};
            }
        });
    });
